export const getLanguages = () => [
  {
    lang: 'pl',
    value: 'Polski',
    locale: 'pl-PL',
  },
  {
    lang: 'en',
    value: 'Angielski',
    locale: 'en-US',
  },
  {
    lang: 'hu',
    value: 'Węgierski',
    locale: 'hu-HU',
  },
  {
    lang: 'ua',
    value: 'Ukraiński',
    locale: 'uk-UA',
  },
];

export const getLanguageByLang = (lang) => getLanguages().find((l) => l.lang === lang);

export const DEFAULT_LANGUAGE = 'pl';
